export default "__VITE_PUBLIC_ASSET__e4032e5d__"